module.exports = __webpack_public_path__ + "app/components/wz/configuration-qws.view.html";